import React from "react"
import styles from "./styles.scss"
import cx from "classnames"
import FaIcon from "@fortawesome/react-fontawesome"

const ListItem = ({ text, className }) => (
  <li className={cx(styles.listitem, className)}>
    <FaIcon icon="caret-right" className={styles.icon} />
    <span className={styles.text}>{text}</span>
  </li>
)

export default ListItem



// WEBPACK FOOTER //
// ./src/components/ListItem/index.jsx